export const normalizeIban = (value?: string): string =>
    (value ?? "").replace(/\s+/g, "").toUpperCase();

export const formatIban = (value?: string): string =>
    normalizeIban(value).replace(/(.{4})(?=.)/g, "$1 ");

export const isValidIban = (value?: string): boolean => {
    const iban = normalizeIban(value);
    if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)) return false;

    const rearranged = iban.slice(4) + iban.slice(0, 4);
    let remainder = 0;
    for (const character of rearranged) {
        const numeric = /[A-Z]/.test(character)
            ? String(character.charCodeAt(0) - 55)
            : character;
        for (const digit of numeric) {
            remainder = (remainder * 10 + Number(digit)) % 97;
        }
    }
    return remainder === 1;
};
